function Info({ fill = "#2E5BFF" }) {
  return (
    <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29 0C12.9835 0 0 12.984 0 29C0 45.0169 12.9835 58 29 58C45.0165 58 58 45.0169 58 29C58 12.984 45.0165 0 29 0ZM29 43.5C26.9979 43.5 25.375 41.8778 25.375 39.875C25.375 37.8731 26.9979 36.25 29 36.25C31.0021 36.25 32.625 37.8731 32.625 39.875C32.625 41.8778 31.0021 43.5 29 43.5ZM32.625 30.8125H25.375L23.5625 16.3125C23.5625 15.3115 24.374 14.5 25.375 14.5H32.625C33.626 14.5 34.4375 15.3115 34.4375 16.3125L32.625 30.8125Z"
        fill={fill}
      />
    </svg>
  );
}

export default Info;
